<template>
  <footer class="mobile_footer">
    <div class="mobile_footer__inner">
      <!-- Logo -->
      <router-link to="/home" class="mobile_footer__logoLink" aria-label="AiLife Home">
        <el-image :src="logoUrl" fit="contain" class="mobile_footer__logo" alt="AiLife Diagnostics">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </router-link>

      <!-- Contact Us -->
      <section class="mobile_footer__contact">
        <div class="mobile_footer__sectionTitle">Contact Us</div>

        <div class="mobile_footer__info">
          <div class="mobile_footer__infoRow">
            <i class="el-icon-location-outline"></i>
            <div>1920 Country Pl Pkwy, Suite 100, Pearland, TX 77584</div>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-phone-outline"></i>
            <a href="tel:+13463421802">(346) 342-1802</a>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-printer"></i>
            <a href="fax:+13463306319">(346) 330-6319</a>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-message"></i>
            <a href="mailto:contact@ailifeus.com">contact@ailifeus.com</a>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-time"></i>
            <div>
              <div class="mobile_footer__label">Client Services</div>
              <div class="mobile_footer__text">
                8:30 am—5:30 pm CDT, Monday—Friday
              </div>
            </div>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-time"></i>
            <div>
              <div class="mobile_footer__label">Sample Receiving</div>
              <div class="mobile_footer__text">
                8:30 am—5:30 pm CDT, Monday—Saturday
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Link Sections -->
      <section class="mobile_footer__nav" aria-label="Footer navigation">
        <div class="mobile_footer__navItem">
          <button
            type="button"
            class="mobile_footer__navHeader"
            :class="{ 'is-open': activeSection === 'test' }"
            :aria-expanded="activeSection === 'test' ? 'true' : 'false'"
            aria-controls="mobile-footer-test-menu"
            @click="toggleFooterSection('test')"
          >
            <span>Test Menu</span>
            <i class="el-icon-arrow-down"></i>
          </button>

          <transition name="mobile-footer-panel">
            <ul v-show="activeSection === 'test'" id="mobile-footer-test-menu" class="mobile_footer__list">
              <li>
                <router-link to="/test/WholeGenomeSequencingProbandOnly">
                  Whole Genome Sequencing
                </router-link>
              </li>
              <li>
                <router-link to="/test/WholeExomeSequencingProbandOnly">
                  Whole Exome Sequencing
                </router-link>
              </li>
              <li>
                <router-link to="/test/clinical-specialties">
                  Clinical Specialties
                </router-link>
              </li>
            </ul>
          </transition>
        </div>

        <div class="mobile_footer__navItem">
          <button
            type="button"
            class="mobile_footer__navHeader"
            :class="{ 'is-open': activeSection === 'about' }"
            :aria-expanded="activeSection === 'about' ? 'true' : 'false'"
            aria-controls="mobile-footer-about-menu"
            @click="toggleFooterSection('about')"
          >
            <span>About Us</span>
            <i class="el-icon-arrow-down"></i>
          </button>

          <transition name="mobile-footer-panel">
            <ul v-show="activeSection === 'about'" id="mobile-footer-about-menu" class="mobile_footer__list">
              <li>
                <router-link to="/about/mission">
                  Our Mission
                </router-link>
              </li>
              <li>
                <router-link to="/about/licenses">
                  Our Licenses
                </router-link>
              </li>
              <li>
                <router-link to="/join">
                  Careers
                </router-link>
              </li>
              <li>
                <router-link to="/about/privacy">
                  Privacy Policy
                </router-link>
              </li>
            </ul>
          </transition>
        </div>
      </section>

      <!-- Copyright -->
      <div class="mobile_footer__bottom">
        © {{ currentYear }} AiLife Diagnostics. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "mobile_footer",

  data() {
    return {
      activeSection: "test",
      currentYear: new Date().getFullYear(),
      logoUrl: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/logo2.png",
    };
  },

  methods: {
    toggleFooterSection(section) {
      this.activeSection = this.activeSection === section ? "" : section;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_footer {
  width: 100%;
  background: #2b63b6;
  color: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;

  .mobile_footer__inner {
    width: 100%;
    padding: 34px 18px 18px;
    box-sizing: border-box;
  }

  .mobile_footer__logoLink {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    text-decoration: none;
  }

  .mobile_footer__logo {
    width: 190px;
    height: 76px;
    display: block;
  }

  .mobile_footer__contact {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 18px;
    padding: 18px 16px;
    margin-bottom: 18px;
    box-sizing: border-box;
    box-shadow: 0 10px 24px rgba(10, 35, 78, 0.12);
  }

  .mobile_footer__sectionTitle {
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 0.3px;
    color: rgba(255, 255, 255, 0.98);
    margin-bottom: 14px;
  }

  .mobile_footer__info {
    display: grid;
    gap: 12px;
  }

  .mobile_footer__infoRow {
    display: grid;
    grid-template-columns: 20px 1fr;
    gap: 10px;
    align-items: start;
    font-size: 13px;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.86);

    i {
      margin-top: 3px;
      color: rgba(255, 255, 255, 0.92);
      font-size: 16px;
    }

    a {
      color: rgba(255, 255, 255, 0.92);
      text-decoration: none;
      word-break: break-word;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  .mobile_footer__label {
    font-size: 12px;
    font-weight: 800;
    color: rgba(255, 255, 255, 0.94);
    margin-bottom: 2px;
  }

  .mobile_footer__text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.82);
  }

  .mobile_footer__nav {
    display: grid;
    gap: 10px;
    margin-top: 2px;
  }

  .mobile_footer__navItem {
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 10px 24px rgba(10, 35, 78, 0.1);
  }

  .mobile_footer__navHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 50px;
    padding: 0 15px;
    border: none;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.98);
    font-size: 15px;
    font-weight: 800;
    line-height: 1.2;
    text-align: left;
    box-sizing: border-box;
    cursor: pointer;

    i {
      flex: 0 0 auto;
      margin-left: 12px;
      color: rgba(255, 255, 255, 0.86);
      font-size: 15px;
      transition: transform 0.22s ease;
    }

    &.is-open {
      background: rgba(255, 255, 255, 0.12);

      i {
        transform: rotate(180deg);
      }
    }
  }

  .mobile_footer__list {
    list-style: none;
    padding: 6px 15px 11px;
    margin: 0;
    background: rgba(20, 66, 137, 0.24);

    li {
      margin: 0;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    a {
      display: block;
      padding: 12px 0;
      color: rgba(255, 255, 255, 0.86);
      text-decoration: none;
      font-size: 13.5px;
      line-height: 1.4;
      word-break: break-word;
    }

    a:hover {
      color: #ffffff;
      text-decoration: underline;
    }
  }

  .mobile-footer-panel-enter-active,
  .mobile-footer-panel-leave-active {
    overflow: hidden;
    transition: max-height 0.22s ease, opacity 0.18s ease;
  }

  .mobile-footer-panel-enter,
  .mobile-footer-panel-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .mobile-footer-panel-enter-to,
  .mobile-footer-panel-leave {
    max-height: 320px;
    opacity: 1;
  }

  .mobile_footer__bottom {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.13);
    text-align: center;
    font-size: 12px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.68);
  }
}

@media screen and (max-width: 375px) {
  .mobile_footer {
    .mobile_footer__inner {
      padding: 30px 14px 16px;
    }

    .mobile_footer__logo {
      width: 172px;
      height: 68px;
    }

    .mobile_footer__contact {
      padding: 16px 14px;
    }

    .mobile_footer__infoRow {
      font-size: 12.5px;
    }
  }
}
</style>
ize: 12.5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/footer/footer.vue